import { gql } from '@apollo/client';

export default gql`
  query PanelistVanityStatsQuery($workspaceId: Int!, $filter: UserFilter) {
    allPanelists(workspaceId: $workspaceId, filter: $filter) {
      totalCount
    }
  }
`;
